// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileButton_wrapper__55feB","actionButton":"MobileButton_actionButton__nFZn+","buttonText":"MobileButton_buttonText__jel0P"};